import { render, staticRenderFns } from "./EditProducer.vue?vue&type=template&id=01f65dc8&scoped=true&"
import script from "./EditProducer.vue?vue&type=script&lang=js&"
export * from "./EditProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f65dc8",
  null
  
)

export default component.exports